import React, { useState } from 'react';
import { Button, Col, Row, Upload, Icon } from '@oscar/theme';
import { AddedFormProps } from 'common/components/FormList/types';
import apiClient from '@oscar/request';
import './style.scss';
import { reduce, round } from 'lodash';

const { Dragger } = Upload;

const CreateForm = (props: AddedFormProps) => {
  const [isShowMesError, setIsShowMesError] = useState(false);
  const [isShowError, setIsShowError] = useState(false);
  const [isShowMesErrorSize, setIsShowMesErrorSize] = useState(false);
  const { readOnly, addItem, removeItem, request, title, data } = props;
  if (readOnly) {
    return null;
  }
  const getFileName = (str: string) => {
    if (!str) return '';
    return str.substring(str.lastIndexOf('/') + 1, str.lastIndexOf('.'));
  };

  const totalSize = reduce(data, (sum: any, item: any) => sum + item?.size, 0);
  const allowedFileTypes = [
    '.pdf',
    '.docx',
    '.xlsx',
    '.txt',
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.pptx',
  ];

  const uploadedProps = {
    multiple: true,
    showUploadList: false,
    beforeUpload: (file: any) => {
      // Block files at the browser level
      const fileExtension = file.name
        .toLowerCase()
        .substring(file.name.lastIndexOf('.'));
      if (!allowedFileTypes.includes(fileExtension)) {
        setIsShowError(true);
        return false; // Prevent upload
      }
      setIsShowError(false);
      return true;
    },
    onDrop(e: any) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    customRequest(args: any) {
      const { file } = args;
      const formData = new FormData();
      const fileNameNew = getFileName(file.name);
      if (fileNameNew.length > 40) {
        setIsShowMesError(true);
        return;
      } else {
        setIsShowMesError(false);
      }
      setIsShowError(false);
      formData.append('file', file);
      return apiClient
        .request({
          ...request,
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(res => {
          res.data.forEach((item: any) => {
            if (item?.size + totalSize < 31457280) {
              addItem?.(item);
              setIsShowMesErrorSize(false);
            } else {
              setIsShowMesErrorSize(true);
            }
          });
          return res;
        })
        .catch(error => {
          setIsShowError(true);
        });
    },
  };
  return (
    <div>
      <div className="file-uploaded-detail">
        <div className="file-uploaded-detail-title">
          {title ? title : 'Attachment'}
        </div>
        <div className="file-uploaded-detail-content">
          <Row>
            <Col span={24}>
              <Dragger {...uploadedProps}>
                <div className="ant-upload-drag-icon">
                  <Icon icon="folder-upload" size={32} color="#8D8D8D" />
                </div>
                <div className="file-uploaded-detail-content-hint">
                  Drag and drop file here
                  <br /> or
                </div>
                <Button type="secondary" size="middle">
                  Browse for file
                </Button>
                <div className="file-uploaded-detail-content-hint">
                  Supported file types: {allowedFileTypes.join(',')}
                </div>
              </Dragger>
            </Col>
          </Row>
        </div>
      </div>
      {isShowMesError && (
        <p className="error-message">
          The Attachment file name is too long. Maximum 40 characters.
        </p>
      )}
      {isShowMesErrorSize && (
        <p className="error-message">
          The Attachment file size exceeds the allowable limit
        </p>
      )}
      {isShowError && (
        <p className="error-message">
          Invalid file type. Please upload a valid file type.
        </p>
      )}
    </div>
  );
};

export default CreateForm;
